"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * WordPress dependencies
 */
var React = require("react");
var _ = require("lodash");
var components_1 = require("@wordpress/components");
var globals_1 = require("@/globals");
var cogicon_svg_1 = require("@/../cogicon.svg");
var PreviewForm = /** @class */ (function (_super) {
    __extends(PreviewForm, _super);
    function PreviewForm(props) {
        var _this = _super.call(this, props) || this;
        // Generate a unique identifier, so that the embed script can be identified
        // and removed from the page once it is no longer needed.
        _this.state = {
            uniqueId: _.uniqueId(),
            loading: true,
        };
        return _this;
    }
    PreviewForm.prototype.componentDidMount = function () {
        this.loadEmbedScript(this.formReady.bind(this));
    };
    PreviewForm.prototype.componentWillUnmount = function () {
        this.removeEmbedScript();
    };
    // Force the embed script to load, which makes Iframes in the editor resize properly.
    PreviewForm.prototype.loadEmbedScript = function (callback) {
        var existingScript = document.getElementById("cog-embed-script-".concat(this.state.uniqueId));
        if (!existingScript) {
            var script = document.createElement('script');
            script.src = "".concat(globals_1.baseUrl, "/f/iframe.js");
            script.id = "cog-embed-script-".concat(this.state.uniqueId);
            document.body.appendChild(script);
            script.onload = function () {
                if (callback)
                    callback();
            };
        }
        if (existingScript && callback)
            callback();
    };
    // Clean up before block is removed
    PreviewForm.prototype.removeEmbedScript = function () {
        var existingScript = document.getElementById("cog-embed-script-".concat(this.state.uniqueId));
        if (existingScript) {
            existingScript.remove();
        }
    };
    // Check if form is loaded
    PreviewForm.prototype.formReady = function () {
        this.setState({ loading: false });
    };
    PreviewForm.prototype.render = function () {
        return (React.createElement("div", { className: "form-preview" },
            React.createElement("div", { className: "focus-grabber" }),
            this.state.loading &&
                React.createElement("div", { className: "loader" },
                    React.createElement("div", { className: "icon" },
                        React.createElement(cogicon_svg_1.ReactComponent, null)),
                    React.createElement("p", null, "Loading..."),
                    React.createElement(components_1.Spinner, null)),
            React.createElement("div", { className: "cog-wp-embed cog-wp-embed__preview", dangerouslySetInnerHTML: { __html: this.props.embedCode }, id: "cog-form-".concat(this.state.uniqueId) })));
    };
    return PreviewForm;
}(React.Component));
exports.default = PreviewForm;
